<template>
  <div class="about">
    <!-- Hero Section with Image 5 as Banner -->
    <div class="hero-banner">
      <img src="@/assets/images/image 5.png" alt="Business Technology" class="hero-image" />
      <div class="hero-content">
        <h1 class="hero-title">
          <div>EMPOWERING BUSINESSES THROUGH</div>
          <div>SMART TECHNOLOGY</div>
        </h1>
      </div>
    </div>

    <!-- Mission Section -->
    <div class="mission-section">
      <div class="container">
        <div class="mission-content">
          <h2>Our Mission</h2>
          <div class="mission-text">
            <p>At Advanced Innovatics Solutions, we deliver technology solutions that drive measurable value and long-term success. We partner closely with our clients to understand their goals, challenges, and ambitions, building reliable, scalable, and innovative IT services that make a real difference.</p>
            <p>We believe technology should do more than just function, it should create impact. Whether enhancing operations, unlocking new opportunities, or transforming customer experiences, we help businesses use tech strategically to thrive in a digital world.</p>
            <div class="mission-footer">
              <p>We help companies embrace digital transformation through modern IT solutions that streamline operations, boost efficiency, and unlock new growth opportunities. From strategy to implementation, we guide businesses every step of the way.</p>
              
              <!-- Image Gallery Section -->
              <div class="gallery-section">
                <h3>Our Work in Action</h3>
                <div class="gallery-grid">
                  <div class="gallery-item">
                    <img src="@/assets/images/image 2.png" alt="Our Technology Solutions" class="gallery-image" />
                    <router-link to="/services" class="gallery-caption">Innovative Solutions</router-link>
                  </div>
                  <div class="gallery-item">
                    <img src="@/assets/images/image 4.png" alt="Digital Transformation" class="gallery-image" />
                    <div class="gallery-caption">Digital Transformation</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section (mirrors Home.vue) -->
    <section class="cta">
      <div class="container">
        <div class="cta-social" style="order: -1; justify-content: flex-start; text-align: left;">
          <div class="social-title">Follow us!</div>
          <div class="social-icons">
            <a href="#" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
            <!-- <a href="#" aria-label="Instagram" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a href="#" aria-label="Facebook" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'facebook-f']" />
            </a>
            <a href="#" aria-label="Twitter" class="social-icon" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a> -->
          </div>
        </div>
        <div class="cta-content" style="order: 1;">
          <h2>Ready to transform your business?</h2>
          <router-link to="/contact" class="btn btn-white">Let's connect</router-link>
          <div class="cta-footer">Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
  data() {
    return {
      showInnovativeModal: false,
      innovativeSolutionContent: 'Introducing the Electronic Chip Reader solution — Our Fast Response to Romania\'s New Electronic ID Cards\n\nThe new generation of Romanian electronic ID cards brings clear benefits, such as improved security and no more renewals when you change your home address. But as often happens in technology, one solved problem creates another, since the address is no longer printed, verifying it digitally becomes essential.\n\nAt Advanced Innovatics Solutions, we acted fast. Our new solution, eID Card Reader, enables secure reading and validation of all key data directly from the electronic ID document, including the information no longer visible on the physical card. Tested successfully with the official e-ID test cards, eID Card Reader ensures that institutions and businesses can seamlessly adapt to the new identity model, maintaining trust, compliance, and efficiency in every verification.\n\nWith the eID Card Reader, verifying an electronic ID document is simple and intuitive. The user just opens the app, holds the ID card near the phone, and follows a clear, guided process displayed on the screen. In a few seconds, eID Card Reader securely reads the data from the chip, no technical knowledge or extra configuration being required. The interface was designed for clarity and speed, making digital identity verification an easy process that everyone can follow.'
    }
  },
  metaInfo: {
    title: 'About Us - Advanced Innovatics Solutions',
    meta: [
      { name: 'description', content: 'Learn about our mission to empower businesses through smart technology and innovative IT solutions.' }
    ]
  }
}
</script>

<!-- Modal for Innovative Solutions -->
<transition name="fade">
  <div v-if="showInnovativeModal" class="modal-overlay" @click.self="showInnovativeModal = false">
    <div class="modal-content">
      <button class="modal-close" @click="showInnovativeModal = false">&times;</button>
      <div class="banners-container">
        <div class="banner">
          <img src="@/assets/images/image 2.png" alt="Our Technology Solutions" class="modal-banner" />
        </div>
        <div class="banner">
          <img src="@/assets/images/image 4.png" alt="Digital Transformation" class="modal-banner" />
        </div>
      </div>
      <h2>Introducing the Electronic Chip Reader solution — Our Fast Response to Romania's New Electronic ID Cards</h2>
      <div class="modal-body">
        <p v-for="(paragraph, index) in innovativeSolutionContent.split('\n\n').slice(1)" :key="index">{{ paragraph }}</p>
      </div>
    </div>
  </div>
</transition>

<style scoped>
/* Hero Banner Styles */
.hero-banner {
  position: relative;
  width: 100%;
  max-height: 600px;
  overflow: hidden;
  margin-bottom: 4rem;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hero-content {
  position: absolute;
  top: -75.6px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.5) 50%,
    rgba(0, 0, 0, 0.3) 100%
  );
}

.hero-title {
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0;
  padding: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-title div {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
}

/* Remove old hero section styles */
.hero-section,
.hero-overlay {
  display: none;
}

/* Mission Section */
.mission-section {
  padding: 0 0 6rem;
}

.mission-content {
  max-width: 900px;
  margin: 0 auto;
}

.mission-content h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-weight: 600;
  position: relative;
  padding-bottom: 0.75rem;
}

.mission-content h2::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 4px;
  background-color: #4361ee;
  border-radius: 2px;
}

.mission-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
}

.mission-text p {
  margin-bottom: 1.5rem;
}

.mission-text p:last-child {
  margin-bottom: 0;
}

/* Gallery Section */
.gallery-section {
  margin-top: 4rem;
}

.gallery-section h3 {
  font-size: 1.75rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: left;
  position: relative;
  padding-bottom: 1rem;
}

.gallery-section h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  transform: none;
  width: 80px;
  height: 3px;
  background-color: #4361ee;
  border-radius: 2px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.gallery-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 250px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.gallery-item:hover .gallery-image {
  transform: scale(1.05);
}

.gallery-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: white;
  padding: 1.5rem 1rem 1rem;
  text-align: center;
  font-weight: 600;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  cursor: pointer;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  text-decoration: underline;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

.modal-content h2 {
  color: #2c3e50;
  margin: 1rem 0 1.5rem;
  font-size: 1.5rem;
  line-height: 1.4;
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
}

.banners-container {
  display: flex;
  gap: 1.5rem;
  margin: 1rem 0 2rem;
  justify-content: center;
  max-height: 60vh;
  overflow: hidden;
}

.banner {
  flex: 1;
  max-width: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.modal-banner {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.modal-body {
  line-height: 1.8;
  color: #4a5568;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #eee;
}

.modal-body p {
  margin-bottom: 1.5rem;
}

.modal-body p:last-child {
  margin-bottom: 0;
}

/* Fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.gallery-item:hover .gallery-caption {
  opacity: 1;
  transform: translateY(0);
}

/* Responsive Adjustments */
@media (max-width: 1200px) {
  .hero-title {
    font-size: 2.2rem;
  }
}

@media (max-width: 992px) {
  .hero-banner {
    max-height: 500px;
  }
  
  .hero-title {
    font-size: 2rem;
    padding: 1.5rem;
  }
}

@media (max-width: 768px) {
  .hero-banner {
    max-height: 400px;
  }
  
  .hero-title {
    font-size: 1.8rem;
    text-align: center;
  }
  
  .hero-content {
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.5) 100%
    );
  }
}

@media (max-width: 480px) {
  .hero-banner {
    max-height: 350px;
  }
  
  .hero-title {
    font-size: 1.5rem;
    padding: 1rem;
  }
}

/* CTA Section (mirrors Home.vue) */
.cta {
  background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
  color: white;
  text-align: left;
  padding: 6rem 0;
  margin-top: 4rem;
}

.cta .container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* allow footer to sit under the button */
  gap: 1rem;
}

.cta .cta-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap; /* required per request */
}

.cta .cta-content .cta-footer {
  flex: 0 0 100%; /* required per request */
  text-align: left; /* required per request */
  margin-top: 0.75rem; /* required per request */
  color: rgba(255, 255, 255, 0.9); /* footer color to match image */
  font-size: 0.95rem;
}

.cta .btn-white {
  background: transparent;
  color: #ffffff;
  border: 3px solid #ffffff;
  border-radius: 9999px;
  padding: 0.75rem 1.75rem;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.1;
  text-decoration: none;
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-social {
  display: flex;
  flex-direction: row; /* title and icons on same line */
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  text-align: left;
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem; /* match Home.vue */
  color: #ffffff;
}

.cta .cta-social .social-icons {
  display: flex;
  gap: 1rem;
}

.cta .cta-social .social-icon {
  width: 64px; /* match Home.vue */
  height: 64px; /* match Home.vue */
  border: 3px solid #ffffff; /* match Home.vue */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.25rem; /* match Home.vue */
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Ensure CTA heading is white */
.cta h2 {
  color: #ffffff;
}

@media (max-width: 576px) {
  .cta .container {
    flex-direction: column;
    align-items: flex-start;
  }
  .cta .cta-content {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
